import { useEffect, useState, useRef } from "react"
import {
    Button,
    Col,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Form,
    FormFeedback,
    FormGroup,
    Input,
    Label,
    Row
} from "reactstrap"
import spdlogo from "../assets/speedeon-logo-horiz.svg"
import successcheck from "../assets/check-circle-fill.svg"
import UsStates from "../helpers/helpers"
import ReCAPTCHA from "react-google-recaptcha";

import classNames from 'classnames'

const OptOutForm = () => {
    const recaptcha = useRef();
    const [removalType, setRemovalType] = useState({});
    // eslint-disable-next-line
    const [removalTypeValid, setRemovalTypeValid] = useState()
    const [removalTypeFocused, setRemovalTypeFocused] = useState(false)
    const [removalTypeEdited, setRemovalTypeEdited] = useState(false)

    const [firstName, setFirstName] = useState('')
    // eslint-disable-next-line
    const [firstNameValid, setFirstNameValid] = useState()
    const [firstNameFocused, setFirstNameFocused] = useState(false)
    const [firstNameEdited, setFirstNameEdited] = useState(false)

    const [lastName, setLastName] = useState('')
    // eslint-disable-next-line
    const [lastNameValid, setLastNameValid] = useState()
    const [lastNameFocused, setLastNameFocused] = useState(false)
    const [lastNameEdited, setLastNameEdited] = useState(false)

    const [email, setEmail] = useState('')
    // eslint-disable-next-line
    const [emailValid, setEmailValid] = useState()
    const [emailFocused, setEmailFocused] = useState(false)
    const [emailEdited, setEmailEdited] = useState(false)
    
    const [phone, setPhone] = useState('')
    // eslint-disable-next-line
    const [phoneValid, setPhoneValid] = useState(true)
    const [phoneFocused, setPhoneFocused] = useState(false)
    const [phoneEdited, setPhoneEdited] = useState(false)

    const [address1, setAddress1] = useState('')
    // eslint-disable-next-line
    const [address1Valid, setAddress1Valid] = useState()
    const [address1Focused, setAddress1Focused] = useState(false)
    const [address1Edited, setAddress1Edited] = useState(false)

    const [address2, setAddress2] = useState('')
    const [address2Valid, setAddress2Valid] = useState(true)
    const [address2Focused, setAddress2Focused] = useState(false)
    const [address2Edited, setAddress2Edited] = useState(false)

    const [city, setCity] = useState('')
    // eslint-disable-next-line
    const [cityValid, setCityValid] = useState()
    const [cityFocused, setCityFocused] = useState(false)
    const [cityEdited, setCityEdited] = useState(false)

    const [state, setState] = useState('')
    const [stateName, setStateName] = useState('')
    // eslint-disable-next-line
    const [stateValid, setStateValid] = useState()
    const [stateEdited, setStateEdited] = useState(false)
    const [zip, setZip] = useState('')
    // eslint-disable-next-line
    const [zipValid, setZipValid] = useState()
    const [zipFocused, setZipFocused] = useState(false)
    const [zipEdited, setZipEdited] = useState(false)

    const [error, setError] = useState(null)
    const [statesDropDownIsOpen, setStatesDropdownIsOpen] = useState(false)
    const [formValid, setFormValid] = useState(false)
    const [captchaValid, setCaptchaValid] = useState()
    const [captchaToken, setCaptchaToken] = useState('')
    const [success, setSuccess] = useState(false)
    const [loaded, setLoaded] = useState(false)
    const NAME_REGEX = /^[a-zA-Z]+([ \-']{0,1}[a-zA-Z]+){0,2}[.]{0,1}$/


    const onHandleOptOutSubmit = async (e) => {
        e.preventDefault()

        const validForm = validateForm();
        if (!validForm) {
            setEditedState(true)
            return;
        }

        if (!validForm || !captchaValid) { return; }

        
        setFormValid(false);
        setCaptchaValid(false);
        
        const deletion = removalType.deletion || 0;
        const optOut = removalType.optOut || 0;
        const sensitiveData = removalType.sensitiveData || 0;
        const firstNameF = firstName.toUpperCase();
        const lastNameF = lastName.toUpperCase();
        const emailF = email.toLowerCase();
        const phoneF = phone.replace(/^\d+$/, phone);
        const address1F = address1.toUpperCase();
        const address2F = address2.toLowerCase();
        const cityF = city.toUpperCase();
        const stateF = state.toUpperCase();

        const optout = {
            deletion,
            optOut,
            sensitiveData,
            firstNameF,
            lastNameF,
            emailF,
            address1F,
            address2F,
            phoneF,
            cityF,
            stateF,
            zip,
            captchaToken
        }
        
        const response = await fetch('/api/optouts', {
            method: 'POST',
            body: JSON.stringify(optout),
            headers: {
                'Content-Type': 'application/json'
            }
        })
        const json = await response.json()

        if (!response.ok) {
            setError(json.error)
        }
        if (response.ok) {
            setRemovalType({deletion:0, optOut:0, sensitiveData:0})
            setFirstName('')
            setLastName('')
            setEmail('')
            setPhone('')
            setAddress1('')
            setAddress2('')
            setCity('')
            setState('')
            setZip('')
            setError(null);
            setSuccess(true);
            setCaptchaToken(null)
            setCaptchaValid(false)
        }
    }

    const setEditedState = (edited) => {
        setRemovalTypeEdited(edited)
        setFirstNameEdited(edited)
        setLastNameEdited(edited)
        setEmailEdited(edited)
        setPhoneEdited(edited)
        setAddress1Edited(edited)
        setCityEdited(edited)
        setStateEdited(edited)
        setZipEdited(edited)
    }

    const validateNames = (name) => {
        let valid = false;
        valid = NAME_REGEX.test(name) && name.length <= 100;
        return valid;
    }

    const validateForm = () => {
        const fieldsValid = (
            removalTypeValid &&
            firstNameValid &&
            lastNameValid &&
            address1Valid &&
            emailValid &&
            phoneValid &&
            cityValid &&
            stateValid &&
            zipValid &&
            captchaValid);
        if (
            !fieldsValid
        ) {
            setFormValid(false);
            return false;
        } else {
            setFormValid(true);
            return true;
        }
    }

    const handleRemovalTypeChange = (e) => { 
        const key = e.target.id;
        let type = removalType;
        type[key] = (e.target.checked) ? 1 : 0;
        setRemovalType(type);
        setRemovalTypeEdited(true);
        setRemovalTypeValid(validateRemovalType());
    };

    const validateRemovalType = () => {
        if (!removalType.deletion && !removalType.optOut && !removalType.sensitiveData) {
            return false;
        } else {
            return true;
        }
    }

    const validateEmail = (email) => {
        // eslint-disable-next-line
        const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
        if (emailRegex.test(email) && email.length <= 255) {
            return true;
        } else {
            return false;
        }
    }

    const validatePhone = (phone) => {
        const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        if (!phone.length) { return true; }
        if (phoneRegex.test(phone)) {
            return true;
        } else {
            return false;
        }
    }

    const validateCaptcha = (e) => {
        
        const validate = async () => {
            const captchaValue = recaptcha.current.getValue();
    
            if (!captchaValue) {
                setCaptchaValid(false)
            } else {
                setCaptchaValid(true);
                setCaptchaToken(captchaValue);
            }
        }
        validate()
    }

     const invalidateCaptcha = () => {
        setCaptchaToken(null)
        setCaptchaValid(false)
     }
    
    useEffect(() => { 
        if (!loaded) { return; }
        // eslint-disable-next-line
    }, [removalType.deletion, removalType.optOut, removalType.sensitiveData]);
    
    useEffect(() => { 
        if (!loaded) { return; }
        const valid = validateNames(firstName) && firstName.length > 1;
        setFirstNameValid(valid);
        setFirstNameEdited(true);
        // eslint-disable-next-line
    }, [firstName])

    useEffect(() => { 
        if (!loaded) { return; }
        const valid = validateNames(lastName) && lastName.length > 1;
        setLastNameValid(valid);
        setLastNameEdited(true)
        // eslint-disable-next-line
    }, [lastName])

    useEffect(() => { 
        if (!loaded) { return; }
        const valid = validateEmail(email) && email.length > 1;
        setEmailValid(valid);
        setEmailEdited(true)
        // eslint-disable-next-line
    }, [email])

    useEffect(() => { 
        if (!loaded) { return; }
        const valid = validatePhone(phone);
        setPhoneValid(valid);
        setPhoneEdited(true)
        // eslint-disable-next-line
    }, [phone])
    

    useEffect(() => { 
        if (!loaded) { return; }
        const valid = address1.length > 5 && address1.length <= 50;
        setAddress1Valid(valid);
        setAddress1Edited(true);
        // eslint-disable-next-line
    }, [address1])

    useEffect(() => { 
        if (!loaded) { return; }
        const valid = address2.length === 0 || (address2.length > 2 && address2.length <= 50);
        setAddress2Valid(valid);
        setAddress2Edited(true);
        // eslint-disable-next-line
    }, [address2])
    
    useEffect(() => { 
        if (!loaded) { return; }
        const valid = city.length > 1 && city.length <= 30;
        setCityValid(valid);
        setCityEdited(true);
        // eslint-disable-next-line
    }, [city])

    useEffect(() => { 
        if (!loaded) { return; }
        const valid = state.length > 1;
        setStateValid(valid);
        setStateEdited(true);
        // eslint-disable-next-line
    }, [state])
    
    useEffect(() => { 
        if (!loaded) { return; }
        const valid = zip.length === 5;
        setZipValid(valid);
        setZipEdited(true);
        // eslint-disable-next-line
    }, [zip])

    const handleStateChange = (e) => {
        setState(e.target.value);
        setStateName(e.target.textContent);
   }

    const toggleStatesDropDown = (e) => {
        setStatesDropdownIsOpen(!statesDropDownIsOpen);
    }
    
    const toggleActiveFocus = (e) => {
        const field = e.target.name;
        switch (field) {
            case ("deletion" || "optOut" || "sensitiveData"):
                setRemovalTypeFocused(true);
                setFirstNameFocused(false);
                setLastNameFocused(false);
                setEmailFocused(false);
                setPhoneFocused(false);
                setAddress1Focused(false);
                setAddress2Focused(false);
                setCityFocused(false);
                setZipFocused(false);
                break;
            case "firstName":
                setRemovalTypeFocused(false);
                setFirstNameFocused(true);
                setLastNameFocused(false);
                setEmailFocused(false);
                setPhoneFocused(false);
                setAddress1Focused(false);
                setAddress2Focused(false);
                setCityFocused(false);
                setZipFocused(false);
                break;
            case "lastName":
                setRemovalTypeFocused(false);
                setLastNameFocused(true);
                setFirstNameFocused(false);
                setEmailFocused(false);
                setPhoneFocused(false);
                setAddress1Focused(false);
                setAddress2Focused(false);
                setCityFocused(false);
                setZipFocused(false);
                break;
            case "email":
                setRemovalTypeFocused(false);
                setLastNameFocused(false);
                setFirstNameFocused(false);
                setEmailFocused(true);
                setPhoneFocused(false);
                setAddress1Focused(false);
                setAddress2Focused(false);
                setCityFocused(false);
                setZipFocused(false);
                break;
            case "phone":
                setRemovalTypeFocused(false);
                setLastNameFocused(false);
                setFirstNameFocused(false);
                setEmailFocused(false);
                setPhoneFocused(true);
                setAddress1Focused(false);
                setAddress2Focused(false);
                setCityFocused(false);
                setZipFocused(false);
                break;
            case "address1":
                setRemovalTypeFocused(false);
                setAddress1Focused(!address1Focused);
                setLastNameFocused(false);
                setFirstNameFocused(false);
                setEmailFocused(false);
                setPhoneFocused(false);
                setAddress2Focused(false);
                setCityFocused(false);
                setZipFocused(false);
                break;
            case "address2":
                setRemovalTypeFocused(false);
                setAddress2Focused(!address2Focused);
                setLastNameFocused(false);
                setAddress1Focused(false);
                setEmailFocused(false);
                setPhoneFocused(false);
                setFirstNameFocused(false);
                setCityFocused(false);
                setZipFocused(false);
                break;
            case "city":
                setRemovalTypeFocused(false);
                setCityFocused(!cityFocused);
                setLastNameFocused(false);
                setAddress1Focused(false);
                setAddress2Focused(false);
                setFirstNameFocused(false);
                setZipFocused(false);
                break;
            case "zip":
                setRemovalTypeFocused(false);
                setZipFocused(!zipFocused);
                setLastNameFocused(false);
                setAddress1Focused(false);
                setAddress2Focused(false);
                setCityFocused(false);
                setFirstNameFocused(false);
                break;
            default:
                break;
        }
    }

    useEffect(() => {
        validateForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        removalType,
        removalTypeValid,
        firstName,
        firstNameValid,
        lastName,
        lastNameValid,
        address1,
        address1Valid,
        address2,
        email,
        emailValid,
        phone,
        phoneValid,
        city,
        cityValid,
        state,
        zip,
        zipValid,
        captchaValid,
    ]);

    useEffect(() => { 
        setLoaded(true)
    }, [])

    return (
        <>
            <header className="logo-header">
                <img alt="" className="speedeon-logo" src={spdlogo}></img>
            </header>
            <div className="container">
                <div className="oo-content">
                <h1>OPT-OUT / Deletion Request</h1>
                <div className="fd-info">
                        <p>Your privacy is very important to us and we want to make sure you are in control of your data. By forwarding this completed form to Speedeon Data, you are asking either to OPT-OUT of Speedeon Data selling your data to third parties or you are asking Speedeon Data to have your data deleted from Speedeon Data’s database. To be transparent, the process is largely the same whether you have asked to OPT-OUT or have your information deleted. We will have your name and address added to a suppression file that will ensure, going forward, that your data will not be sold.</p>
                        
                        <p>Speedeon Data does not collect or maintain most categories of “Sensitive Data.” We do collect data regarding religious affiliation, ethnicity, and self-reported ailment data. If you would like to limit the use of this data, please fill out the form and check the sensitive data checkbox.</p>

                    <p>By completing this form and including your signature, you hereby request, related to your name and address as it exists in Speedeon Data’s marketing database that Speedeon Data LLC cease selling your data to 3rd parties. You confirm that you are the individual who resides at the provided address and that you are 18 years of age or older.</p>

                    <p>Only one name and address may be included on this form. If you would like information for another name and address combination, you will need to complete and provide a separate form.</p>
                </div>
            </div>
             <div className="form-wrap">
                            {!success && !error &&
                        <Form className="opt-out-form" onSubmit={onHandleOptOutSubmit}>
                            <div className={classNames("fd-input checks", { "active": removalTypeFocused, "invalid": !removalTypeValid && removalTypeEdited })}>
                                <Label>Deletion / Opt-Out / Sensitive Data<sup>*</sup></Label>
                                <p className="small">Please select at least one:</p>
                                <FormGroup
                                    check
                                    inline
                                >
                                    <Input
                                        id="deletion"
                                        name="deletion"
                                        onChange={handleRemovalTypeChange}
                                        type="checkbox"
                                        invalid={!removalTypeValid && removalTypeEdited}
                                    />
                                    <Label check>
                                    Deletion
                                    </Label>
                                </FormGroup>
                                <FormGroup
                                    check
                                    inline
                                >
                                    <Input
                                        id="optOut"
                                        name="optOut"
                                        onChange={handleRemovalTypeChange}
                                        type="checkbox"
                                        invalid={!removalTypeValid && removalTypeEdited}
                                    />
                                    <Label check>
                                    Opt-out
                                    </Label>
                                </FormGroup>
                                <FormGroup
                                    check
                                    inline
                                >
                                    <Input
                                        id="sensitiveData"
                                        name="sensitiveData"
                                        onChange={handleRemovalTypeChange}
                                        type="checkbox"
                                        invalid={!removalTypeValid && removalTypeEdited}
                                    />
                                    <Label check>
                                    Sensitive Data
                                    </Label>
                                </FormGroup>
                                    {!removalTypeValid && removalTypeEdited &&
                                        <div className="invalid-feedback">
                                                Please choose one or more options above.
                                        </div>
                                    }
                            </div>
                            <Row>
                                <Col md={6}>
                                    <FormGroup className={classNames("fd-input", { "active": firstNameFocused, "invalid": !firstNameValid && firstNameEdited })}>
                                        <Label>First Name<sup>*</sup></Label>
                                        <Input
                                            type="text"
                                            name="firstName"
                                            onFocus={toggleActiveFocus}
                                            onChange={(e) => setFirstName(e.target.value)}
                                            value={firstName}
                                            invalid={!firstNameValid && firstNameEdited}
                                                />
                                        <FormFeedback invalid>
                                            Invalid - too few or too many characters.
                                        </FormFeedback>
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup className={classNames("fd-input", {"active": lastNameFocused, "invalid": !lastNameValid && lastNameEdited })}>
                                        <Label>Last Name<sup>*</sup></Label>
                                        <Input
                                            type="text"
                                            name="lastName"
                                            onFocus={toggleActiveFocus}
                                            onChange={(e) => setLastName(e.target.value)}
                                            value={lastName}
                                            invalid={!lastNameValid && lastNameEdited}
                                            />
                                        <FormFeedback invalid>
                                            Invalid - too few or too many characters.
                                        </FormFeedback>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <FormGroup className={classNames("fd-input", {"active": emailFocused, "invalid": !emailValid && emailEdited })}>
                                        <Label>Email<sup>*</sup></Label>
                                        <Input
                                            type="email"
                                            name="email"
                                            onFocus={toggleActiveFocus}
                                            onChange={(e) => setEmail(e.target.value)}
                                            value={email}
                                            invalid={!emailValid && emailEdited}
                                            />
                                        <FormFeedback invalid>
                                            Invalid email.
                                        </FormFeedback>
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup className={classNames("fd-input", {"active": phoneFocused, "invalid": !phoneValid && phoneEdited })}>
                                        <Label>Phone</Label>
                                        <Input
                                            type="text"
                                            name="phone"
                                            onFocus={toggleActiveFocus}
                                            onChange={(e) => setPhone(e.target.value)}
                                            value={phone}
                                            invalid={!phoneValid && phoneEdited}
                                            />
                                        <FormFeedback invalid>
                                            Invalid US phone number.
                                        </FormFeedback>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={8}>
                                    <FormGroup className={classNames("fd-input", {"active": address1Focused, "invalid": !address1Valid && address1Edited })}>
                                        <Label>Street Address<sup>*</sup></Label>
                                        <Input
                                            type="text"
                                            name="address1"
                                            onFocus={toggleActiveFocus}
                                            onChange={(e) => setAddress1(e.target.value)}
                                            value={address1}
                                            invalid={!address1Valid && address1Edited}
                                            />
                                        <FormFeedback invalid>
                                            Invalid - too few or too many characters.
                                        </FormFeedback>
                                    </FormGroup>
                                </Col>
                                <Col md={4}>
                                    <FormGroup className={classNames("fd-input", {"active": address2Focused, "invalid": !address2Valid && address2Edited})}>
                                        <Label>Apartment/Suite</Label>
                                        <Input
                                            type="text"
                                            name="address2"
                                            onFocus={toggleActiveFocus}
                                            onChange={(e) => setAddress2(e.target.value)}
                                            value={address2}
                                            invalid={!address2Valid && address2Edited}
                                            />
                                        <FormFeedback>
                                            Invalid - too few or too many characters.
                                        </FormFeedback>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <FormGroup className={classNames("fd-input", {"active": cityFocused, "invalid": !cityValid && cityEdited })}>
                                        <Label>City<sup>*</sup></Label>
                                        <Input
                                            type="text"
                                            name="city"
                                            onFocus={toggleActiveFocus}
                                            onChange={(e) => setCity(e.target.value)}
                                            value={city}
                                            invalid={!cityValid && cityEdited}
                                            />
                                    <FormFeedback invalid>
                                        Invalid - too few or too many characters.
                                    </FormFeedback>
                                </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup className={classNames("fd-input dd", { "invalid": stateValid === false && stateEdited } )}>
                                        <Label>State<sup>*</sup></Label>
                                        <Dropdown
                                            isOpen={statesDropDownIsOpen}
                                            toggle={toggleStatesDropDown}
                                                >
                                                <DropdownToggle className="dd-button" caret block outline color="primary" size="md">{stateName || "Your State of Residence"}</DropdownToggle>
                                                <DropdownMenu>
                                                    {UsStates().map((item, index) => { 
                                                        return (
                                                            <DropdownItem
                                                                key={index}
                                                                value={item.abbreviation}
                                                                title={item.name}
                                                                onClick={handleStateChange}
                                                            >
                                                                {item.name}
                                                            </DropdownItem>
                                                        )
                                                    })}
                                                </DropdownMenu>
                                            </Dropdown>
                                            <FormFeedback>
                                                Please choose a US State.
                                            </FormFeedback>
                                        </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <FormGroup className={classNames("fd-input", {"active": zipFocused, "invalid": !zipValid && zipEdited })}>
                                        <Label>Zip Code<sup>*</sup></Label>
                                        <Input
                                            type="number"
                                            name="zip"
                                            onFocus={toggleActiveFocus}
                                            onChange={(e) => setZip(e.target.value)}
                                            value={zip}
                                            invalid={!zipValid && zipEdited}
                                        /> 
                                        <FormFeedback invalid>
                                            Needs to be 5 digits.
                                        </FormFeedback>
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup className="captcha">
                                        <ReCAPTCHA
                                            ref={recaptcha}
                                            onChange={validateCaptcha}
                                            onExpired={invalidateCaptcha}
                                            sitekey={"6LfGNnMpAAAAAN3h8zeCZqH-tfBH9-m0PIqs_EWw"}
                                            />
                                    </FormGroup>
                                </Col>
                            </Row>
                                <FormGroup>   
                                    <Button
                                        block
                                        color="primary"
                                        className="fd"
                                        type="submit"
                                        disabled={!formValid}
                                    >
                                    SUBMIT
                                    </Button>
                                </FormGroup>
                            </Form>
                            
                            }
                            {success && 
                                <>
                                <div className="success">
                                    <img alt="" src={successcheck}></img>
                                    <h3>Your request has been submitted successfully.</h3>
                                    <p><strong>Please allow up to 35 days to complete your request.</strong></p>
                                </div>
                                </>
                            }
                            {error && 
                                <>
                                <div className="error">
                                    <h3>Sorry, there has been an error submitting your opt out request. Please try again.</h3>
                                    <a href="/">Back</a>
                                </div>
                            </>
                            }
                </div>
            </div>
        </>
    )
}
export default OptOutForm
